import { getTvObject } from '@costar-ui/cosmos';

var radiusOptions = getTvObject({
  radius: {
    none: 'rounded-none',
    sm: 'rounded-sm',
    base: 'rounded',
    md: 'rounded-md',
    lg: 'rounded-lg',
    xl: 'rounded-xl',
    '2xl': 'rounded-2xl',
    '3xl': 'rounded-3xl',
    full: 'rounded-full'
  },
  radiusBottom: {
    none: 'rounded-b-none',
    sm: 'rounded-b-sm',
    base: 'rounded-b',
    md: 'rounded-b-md',
    lg: 'rounded-b-lg',
    xl: 'rounded-b-xl',
    '2xl': 'rounded-b-2xl',
    '3xl': 'rounded-b-3xl',
    full: 'rounded-b-full'
  },
  radiusTop: {
    none: 'rounded-t-none',
    sm: 'rounded-t-sm',
    base: 'rounded-t',
    md: 'rounded-t-md',
    lg: 'rounded-t-lg',
    xl: 'rounded-t-xl',
    '2xl': 'rounded-t-2xl',
    '3xl': 'rounded-t-3xl',
    full: 'rounded-t-full'
  },
  radiusLeft: {
    none: 'rounded-l-none',
    sm: 'rounded-l-sm',
    base: 'rounded-l',
    md: 'rounded-l-md',
    lg: 'rounded-l-lg',
    xl: 'rounded-l-xl',
    '2xl': 'rounded-l-2xl',
    '3xl': 'rounded-l-3xl',
    full: 'rounded-l-full'
  },
  radiusRight: {
    none: 'rounded-r-none',
    sm: 'rounded-r-sm',
    base: 'rounded-r',
    md: 'rounded-r-md',
    lg: 'rounded-r-lg',
    xl: 'rounded-r-xl',
    '2xl': 'rounded-r-2xl',
    '3xl': 'rounded-r-3xl',
    full: 'rounded-r-full'
  }
});
var radiusOptions$1 = radiusOptions;

export { radiusOptions$1 as default };
//# sourceMappingURL=radius-options.esm.js.map
